import 'boot/webpackPublicPath';
import { exposeComponents } from 'boot/common/reactMount';
import { SearchApp } from 'search/components/SearchApp';

exposeComponents({ SearchApp });
